import { ServicesContainer } from '@/services';
import { ErrorEvent } from '@/services/analytics/events';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AnalyticsError, AnalyticsEventType, WebInteraction } from '../models';
import { AdobeBaseEvent } from './adobe-base-event';

export class AdobeErrorEvent extends AdobeBaseEvent {
    event = AnalyticsEventType.Error;
    error = { errors: { value: 1 } } as AnalyticsError;
  
    constructor(event: ErrorEvent, store: Store<AppState>, services: ServicesContainer) {
      super(store, services);
      this.error.errorName = `${event.errorType}|${event.errorName}`
      this.web.webInteraction = {
        linkModuleName: `${event.errorType}|${event.action}`,
        linkClicks: { value: 1 },
        type: 'other'
      }
    }
  }